module.exports = __webpack_public_path__ + "static/media/event certificate iconG.80b113bf.svg";